import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import NavDropdown from 'react-bootstrap/NavDropdown'
import { Translation } from 'react-i18next'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { HashLink } from 'react-router-hash-link'

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .use(HttpApi)
    .init({
        supportedLngs: ['EN', 'FR'],
        fallbackLng: 'EN',
        backend: {
            loadPath: '/assets/locales/{{lng}}/translation.json',
        },
        react: {
            useSuspense: true,
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ['br', 'strong', 'b', 'i'],
        },
    })

class Header extends Component {
    constructor(props) {
        super(props)
    }

    handleLanguageChange(e) {
        const newLang = e.target.value
        window.location.href = '/' + newLang
    }

    handleTitleClick = (e) => {
        e.preventDefault();
        window.location.href = '/small-loans';
    }

    render() {
        const { t } = this.props

        return (
            <div>
                <Navbar bg="light" expand="lg" fixed="top">
                    <Container>
                        <Navbar.Brand as={Link} to="/">
                            <img
                                src="/assets/img/GGF.png"
                                width="100px"
                                className="logo me-auto navbarStyle"
                                alt="GoodGoodFinance!"
                            />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="me-auto"></Nav>
                            <Nav.Link as={Link} to="/">
                                <Translation>
                                    {(t) => <span>{t('navbar_title1')}</span>}
                                </Translation>
                            </Nav.Link>
                            <Nav.Link as={HashLink} className="is-active" to="/#about">
                                <Translation>
                                    {(t) => <span>{t('navbar_title2')}</span>}
                                </Translation>
                            </Nav.Link>
                            <Nav.Link as={HashLink} to="/#faq">
                                <Translation>
                                    {(t) => <span>{t('navbar_title3')}</span>}
                                </Translation>
                            </Nav.Link>

                            <NavDropdown title="BENEFITS">
                                <NavDropdown.Item
                                    as={Link}
                                    to="/benefits/personnalized-loan"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Personnalized loan
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/benefits/instant-loan"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Instant loan
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/benefits/no-credit-check-loan"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    No credit check loan
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/benefits/no-refusal-loan"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    No refusal loan
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/benefits/instant-etransfer-loan"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Instant E-transfer loan
                                </NavDropdown.Item>
                            </NavDropdown>

                            <NavDropdown title="NEEDS">
                                <NavDropdown.Item
                                    as={Link}
                                    to="/needs/no-refusal-payday-loans"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    No refusal payday loan
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/needs/emergency-loan"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Emergency loan
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/avantages/loan-without-proof-income"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Loan without proof of income
                                </NavDropdown.Item>
                            </NavDropdown>


                            <NavDropdown
                                title={
                                    <span onClick={this.handleTitleClick} style={{ cursor: 'pointer' }}>
                                SMALL LOANS
                                </span>
                                }
                                id="micro-prets-dropdown"
                            >
                                <NavDropdown.Item
                                    as={Link}
                                    to="/small-loans/200"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Small loan of 200$
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/small-loans/300"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Small loan of 300$
                                </NavDropdown.Item>
                            </NavDropdown>

                            <NavDropdown title="SITUATIONS">
                                <NavDropdown.Item
                                    as={Link}
                                    to="/situations/bad-credit-loan"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Bad credit loan
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={Link}
                                    to="/situations/loan-no-job"
                                    style={{ paddingLeft: 15, paddingRight: 15 }}
                                >
                                    Loan no job
                                </NavDropdown.Item>
                            </NavDropdown>

                            <Nav.Link>
                                <select
                                    className="form-select"
                                    value="EN"
                                    onChange={this.handleLanguageChange}
                                    style={{ width: 115 }}
                                >
                                    <option value="FR">Français</option>
                                    <option value="EN">English</option>
                                </select>
                            </Nav.Link>
                            <Link to="/new-lead?sourcePret=GoodGoodFinance&source=GoodGoodFinance" className="getstarted scrollto me-2">
                                <Translation>
                                    {(t) => <span>{t('navbar_button')}</span>}
                                </Translation>
                            </Link>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </div>
        )
    }
}
export default Header
